import { AudioPlayer } from "./AudioPlayer/AudioPlayer";
import { ConnectionStatus } from "./ConnectionStatus/ConnectionStatus";
import { QueuePanel } from "../queue/QueuePanel";
import "./AudioPlayerNavigation.css";

/**
 * Now-playing sidebar: connection status, transport controls, and the
 * queue. The audio itself is owned by PlayerContext, not this component.
 */
export function AudioPlayerNavigation() {
    return (
        <div className="nav audioNav">
            <div className="audioNavStatus">
                <ConnectionStatus />
            </div>
            <AudioPlayer />
            <QueuePanel />
        </div>
    );
}
